import { defineMessage } from 'react-intl';

const incorrectValueMessage = defineMessage({
  defaultMessage: 'Incorrect value',
  id: 'f9Ik/S',
  description: 'Field error message',
});

// name field: no digits and no whitespace, non-empty
const NAME_PATTERN = /^[^\d\s]+$/;

const checkNoDigits = (value: string | null, errorMessage: string): string | undefined => {
  if (!value) {
    return undefined;
  }

  return /\d/.test(value) ? errorMessage : undefined;
};

export { incorrectValueMessage, NAME_PATTERN, checkNoDigits };
